import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { hasTraversalPayload } from './sanitize-bootstrap-url';
import 'hammerjs';
import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-079393}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cisco_Systems,_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{19_May_2026}____[v3]_[01]_MTc3OTE0NTIwMDAwMA==8aae9f3365dd266d8285b1d01dbdcf5e'
);

if (environment.production) {
  enableProdMode();
}

// Scrub traversal-style query strings before Angular Router/OAuth ever parse the URL,
// so malicious input is never echoed back in-app (e.g. re-encoded OAuth state redirects).
if (hasTraversalPayload(window.location.search)) {
  window.history.replaceState(null, '', window.location.pathname);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    // console.log('Application bootstrapped successfully   ', environment.production);
    if ('serviceWorker' in navigator && !environment.production) {
      navigator.serviceWorker.register('ngsw-worker.js');
    }
  })
  .catch(err => console.error(err));